export const PURPOSE_OF_SELECTION_GET_REQUEST = 'PURPOSE_OF_SELECTION_GET_REQUEST';
export const PURPOSE_OF_SELECTION_GET_SUCCESS = 'PURPOSE_OF_SELECTION_GET_SUCCESS';
export const PURPOSE_OF_SELECTION_GET_ERROR = 'PURPOSE_OF_SELECTION_GET_ERROR';
export const PURPOSE_OF_SELECTION_GET_BY_KEY_REQUEST = 'PURPOSE_OF_SELECTION_GET_BY_KEY_REQUEST';
export const PURPOSE_OF_SELECTION_GET_BY_KEY_SUCCESS = 'PURPOSE_OF_SELECTION_GET_BY_KEY_SUCCESS';
export const PURPOSE_OF_SELECTION_GET_BY_KEY_ERROR = 'PURPOSE_OF_SELECTION_GET_BY_KEY_ERROR';
export const PURPOSE_OF_SELECTION_ADD_REQUEST = 'PURPOSE_OF_SELECTION_ADD_REQUEST';
export const PURPOSE_OF_SELECTION_ADD_SUCCESS = 'PURPOSE_OF_SELECTION_ADD_SUCCESS';
export const PURPOSE_OF_SELECTION_ADD_ERROR = 'PURPOSE_OF_SELECTION_ADD_ERROR';
export const PURPOSE_OF_SELECTION_EDIT_REQUEST = 'PURPOSE_OF_SELECTION_EDIT_REQUEST';
export const PURPOSE_OF_SELECTION_EDIT_SUCCESS = 'PURPOSE_OF_SELECTION_EDIT_SUCCESS';
export const PURPOSE_OF_SELECTION_EDIT_ERROR = 'PURPOSE_OF_SELECTION_EDIT_ERROR';
export const PURPOSE_OF_SELECTION_DELETE_REQUEST = 'PURPOSE_OF_SELECTION_DELETE_REQUEST';
export const PURPOSE_OF_SELECTION_DELETE_SUCCESS = 'PURPOSE_OF_SELECTION_DELETE_SUCCESS';
export const PURPOSE_OF_SELECTION_DELETE_ERROR = 'PURPOSE_OF_SELECTION_DELETE_ERROR';
